(ns practitest.frontend.components.grid.columns-settings
  (:require [goog.object :as gobj]
            ["react-sortable-hoc" :as react-sortable-hoc]
            [reagent.core :as reagent]
            [re-frame.core :as re-frame]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components.overlay :as overlay]
            [practitest.frontend.common.dom :as dom]
            [practitest.frontend.subs :as subs]
            [practitest.frontend.components.react-bootstrap :as react-bootstrap]
            [practitest.frontend.components.grid.common :as gc]
            [practitest.frontend.common.mixpanel :as mixpanel]))


(defn save-settings! [{:keys [local-state-updating
                              columns-settings-save]
                       :as   tableprops}]
  (when columns-settings-save
    (columns-settings-save (select-keys @local-state-updating
                                        [:columns-visibility
                                         :columns-order]))))

(defn reset-saved-settings! [{:keys [local-state-updating
                                columns-settings-save
                                ;; TODO: fix this coupling
                                columns-widths-save]
                         :as   tableprops}]
  (when columns-settings-save
    (columns-settings-save nil))
  (when columns-widths-save
    (columns-widths-save nil)))

(def ColumnsListItem
  (react-sortable-hoc/SortableElement.
    (fn [props]
      (reagent/as-element
        (let [column (gobj/get props "value")
              on-visibility-change (gobj/get props "onVisibilityChange")]
          [:div.list-group-item.list-group-item-action.columns-item
           [:div.drag-handle
            [icons/svg-grip-vertical-reduced]]
           [:div.column-name
            (gc/header-title column)]
           [:div.form-switch.ms-auto
            [:input.form-check-input
             {:type      "checkbox"
              :checked   (:show? column)
              :on-change (fn [e]
                           (let [show? (dom/event-value e)]
                             (on-visibility-change column show?)))}]]])))))

(def ColumnsList
  (react-sortable-hoc/SortableContainer.
    (fn [props]
      (reagent/as-element
        [:div.list-group.columns-list
         (map-indexed
           (fn [idx v]
             [:r>
              ColumnsListItem
              #js {:key         (:field v)
                   :index       idx
                   :onVisibilityChange (gobj/get props "onVisibilityChange")
                   :value       v}])
           (gobj/get props "items"))]))))

; [1 2 3 4 5] 1 3 => [1 3 4 2 5]
; [1 3 4 2 5] 3 1 => [1 2 3 4 5]
(defn vector-move [coll prev-index new-index]
  (let [items (into (subvec coll 0 prev-index)
                    (subvec coll (inc prev-index)))]
    (-> (subvec items 0 new-index)
        (conj (get coll prev-index))
        (into (subvec items new-index)))))

(defn sortable-component
  [items container-ref on-order-change on-visibility-change]
  [:r> ColumnsList
   #js {:items           items
        :helperClass     "columns-item"
        ;; Shadow DOM support
        :helperContainer (fn []
                           @container-ref)
        :useDragHandle   false
        :onVisibilityChange on-visibility-change
        :onSortEnd       (fn [options]
                           (let [old (gobj/get options "oldIndex")
                                 new (gobj/get options "newIndex")]
                             (on-order-change (vector-move items old new))))}])

(defn columns-settings-window
  [{:keys [local-state-updating
           local-columns
           table-container-ref] :as tableprops}]
  [:div
   [sortable-component
    (vec (remove :systemcol? local-columns))
    table-container-ref
    (fn [items]
      (swap! local-state-updating assoc :columns-order (mapv :field items))
      (save-settings! tableprops))
    (fn [column show?]
      (swap! local-state-updating update :columns-visibility assoc (:field column) show?)
      (save-settings! tableprops))]])


;; Slightly different implementation - added "Apply" and "Cancel" buttons, so intermediate state holder is required
(defn columns-settings-window2
  [{:keys [table-container-ref] :as tableprops}
   local-state
   local-columns]
  [:div
   [sortable-component
    (vec (remove :systemcol? local-columns))
    table-container-ref
    (fn [items]
      (swap! local-state assoc :columns-order (mapv :field items)))
    (fn [column show?]
      (swap! local-state update :columns-visibility assoc (:field column) show?))]])

(defn columns-settings-button [{:keys [local-state-updating]
                                :as tableprops}]
  [overlay/overlay
   {:placement "bottom"}
   (fn [overlay-state]
     [:button.btn.btn-outline-primary.btn-sm.nowrap
      {:type     "button"
       :class    (dom/classes-pairs
                   :active (overlay/show? overlay-state))
       :on-click (fn [e]
                   (mixpanel/track "Grid columns" {"Entity" "Testset"})
                   (overlay/on-click-handler overlay-state e))}
      [icons/svg-list-vertical]
      " Columns"])

   [react-bootstrap/popover
    {:class "column-settings-popover"}
    [:div.popover-header
     "Columns reordering"]
    [:div.popover-body.column-settings-body
     [columns-settings-window tableprops]]
    [:div.popover-footer
     [:button.btn.btn-primary
      {:type     "button"
       :on-click (fn [e]
                   (reset-saved-settings! tableprops)
                   (swap! local-state-updating dissoc
                          :columns-widths
                          :columns-order
                          :columns-visibility))}
      "Reset"]]]])
